export default "__VITE_ASSET__qYKrwqwJ__"